import { theme } from "../../styles/AepThemeProvider";

// returns true if the client device is a tablet
export const useTablet = (): boolean => {
  return window.innerWidth <= theme.breakpoints.values.md;
};
